// New code By Khurram bhai
import { useEffect, useRef, useState } from "react";
import { Button, Input, Form, message, Col, Row } from "antd";
import { useHistory, useLocation, useParams } from "react-router-dom";
import CountryPhoneInput, {
  // CountryPhoneInputValue,
  ConfigProvider,
} from "antd-country-phone-input";
import en from "../../../constants/world.json";
import "./style.less";
import {
  //ErrorServices,
  useCreateCompanyUserMutation,
  useFetchCompanyUserByIdQuery,
  useUpdateCompanyUserMutation,
  ErrorServices,
} from "@services";
import { useTypedSelector } from "@hooks";

import Tabs from "@/components/Tabs";
import TomTab from "./TomTab";
import JeTab from "./JeTab";
import customErrorMessage from "@/components/CustomErrorMessage";

const defaultPermissions = [
  "CREATE_TOM_USER",
  "VIEW_TOM_USER",
  "UPDATE_TOM_USER",
  "ENABLE_DISABLE_TOM_USER",
  "DELETE_TOM_USER",
  "CREATE_SECTOR",
  "VIEW_SECTOR",
  "UPDATE_SECTOR",
  "DELETE_SECTOR",
  "CREATE_INDUSTRY",
  "VIEW_INDUSTRY",
  "UPDATE_INDUSTRY",
  "DELETE_INDUSTRY",
  "CREATE_SUB_INDUSTRY",
  "VIEW_SUB_INDUSTRY",
  "UPDATE_SUB_INDUSTRY",
  "DELETE_SUB_INDUSTRY",
  "CREATE_JOB_FUNCTION",
  "VIEW_JOB_FUNCTION",
  "UPDATE_JOB_FUNCTION",
  "DELETE_JOB_FUNCTION",
  "CREATE_JOB_SUB_FUNCTION",
  "VIEW_JOB_SUB_FUNCTION",
  "UPDATE_JOB_SUB_FUNCTION",
  "DELETE_JOB_SUB_FUNCTION",
  "CREATE_COMPANY",
  "VIEW_COMPANY",
  "UPDATE_COMPANY",
  "ENABLE_DISABLE_COMPANY",
  "DELETE_COMPANY",
  "CREATE_LEGAL_ENTITY",
  "VIEW_LEGAL_ENTITY",
  "UPDATE_LEGAL_ENTITY",
  "DELETE_LEGAL_ENTITY",
  "CREATE_GRADE_COMPANY_MAPPING",
  "VIEW_GRADE_COMPANY_MAPPING",
  "UPDATE_GRADE_COMPANY_MAPPING",
  "DELETE_GRADE_COMPANY_MAPPING",
  "CREATE_COMPANY_USER",
  "VIEW_COMPANY_USER",
  "UPDATE_COMPANY_USER",
  "ENABLE_DISABLE_COMPANY_USER",
  "DELETE_COMPANY_USER",
  "CREATE_OFFER",
  "VIEW_OFFER",
  "UPDATE_OFFER",
  "DELETE_OFFER",
  "CREATE_JOB_GRADE",
  "VIEW_JOB_GRADE",
  "UPDATE_JOB_GRADE",
  "DELETE_JOB_GRADE",
  "CREATE_SALARY_RANGE",
  "VIEW_SALARY_RANGE",
  "UPDATE_SALARY_RANGE",
  "DELETE_SALARY_RANGE",
  "CREATE_CASH_ALLOWANCE",
  "VIEW_CASH_ALLOWANCE",
  "UPDATE_CASH_ALLOWANCE",
  "DELETE_CASH_ALLOWANCE",
  "CREATE_COMPANY_STI",
  "VIEW_COMPANY_STI",
  "UPDATE_COMPANY_STI",
  "DELETE_COMPANY_STI",
  "CREATE_COMPANY_LTI",
  "VIEW_COMPANY_LTI",
  "UPDATE_COMPANY_LTI",
  "DELETE_COMPANY_LTI",
  "CREATE_INTERNAL_PAYROLL",
  "VIEW_INTERNAL_PAYROLL",
  "UPDATE_INTERNAL_PAYROLL",
  "DELETE_INTERNAL_PAYROLL",
  "CREATE_MARKET_DATA",
  "VIEW_MARKET_DATA",
  "UPDATE_MARKET_DATA",
  "DELETE_MARKET_DATA",
  "CREATE_JOB_EVALUATION",
  "VIEW_JOB_EVALUATION",
  "UPDATE_JOB_EVALUATION",
];

const companyRolePermissions = {
  COMPANY_SUPER_USER: [
    "CREATE_COMPANY_JOB_FUNCTION",
    "VIEW_COMPANY_JOB_FUNCTION",
    "UPDATE_COMPANY_JOB_FUNCTION",
    "DELETE_COMPANY_JOB_FUNCTION",
    "CREATE_COMPANY_SUB_JOB_FUNCTION",
    "VIEW_COMPANY_SUB_JOB_FUNCTION",
    "UPDATE_COMPANY_SUB_JOB_FUNCTION",
    "DELETE_COMPANY_SUB_JOB_FUNCTION",
  ],

  COMPANY_ADMIN: [
    "CREATE_COMPANY_JOB_FUNCTION",
    "VIEW_COMPANY_JOB_FUNCTION",
    "UPDATE_COMPANY_JOB_FUNCTION",
    "CREATE_COMPANY_SUB_JOB_FUNCTION",
    "VIEW_COMPANY_SUB_JOB_FUNCTION",
    "UPDATE_COMPANY_SUB_JOB_FUNCTION",
  ],

  COMPANY_USER: ["VIEW_COMPANY_JOB_FUNCTION", "VIEW_COMPANY_SUB_JOB_FUNCTION"],

  COMPANY_BUSINESS_ACCESS: [
    "VIEW_COMPANY_JOB_FUNCTION",
    "VIEW_COMPANY_SUB_JOB_FUNCTION",
  ],
};

const CreateCompanyUser = () => {
  let companyUserForm = useRef<any>(null);
  const [form] = Form.useForm();
  const history = useHistory();
  const { user, permissions } = useTypedSelector(state => state.auth);
  const initializeForm = useRef(true);
  const [validateTom, setValidateTom] = useState<() => boolean>(
    () => () => true
  );
  const [validateJe, setValidateJe] = useState<() => boolean>(() => () => true);

  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [newPass, setNewPass] = useState<string>("");
  const [tabs, setTabs] = useState<any>([]);
  // const [applicationArray, setApplicationArray] = useState<string[]>(["TOM"]);
  const [phoneNumber, setPhoneNumber] = useState<any>({
    short: "US",
  });
  const [activeTab, setActiveTab] = useState<number>(1);

  const [tomData, setTomData] = useState<any>({
    grant_access: false,
    name: "",
    description: "",
    metafield: {
      business_units: [],
      regions: [],
      countries: [],
      grades: [],
      job_functions: [],
    },
    role_metafield: {
      has_live_pay_tool: false,
    },
    permissions: [],
  });

  const [jeData, setJeData] = useState<any>({
    JEDashboard: false,
    grant_access: false,
    name: "",
    description: "",
    metafield: {
      business_units: [],
      regions: [],
      countries: [],
      grades: [],
      job_functions: [],
    },
    permissions: [],
  });
  const location = useLocation();

  const params: { company_id: string } = useParams();
  const paramsCompanyId = params.company_id;

  const { id: company_id } = user?.company || { id: paramsCompanyId };
  const [createCompanyUser, { isLoading }] = useCreateCompanyUserMutation();
  const [updateCompanyUser, { isLoading: isUpdating }] =
    useUpdateCompanyUserMutation();
  const { company_user_id } = useParams<{ company_user_id?: string }>();
  const { data } = useFetchCompanyUserByIdQuery(
    {
      company_id,
      id: company_user_id,
    },
    { skip: !company_user_id, refetchOnMountOrArgChange: true }
  );
  const { data: selected_user } = data || {};

  useEffect(() => {
    if (
      user?.company?.applications?.length &&
      tabs?.length === 0 &&
      user?.role !== "TOM_MASTER_USER"
    ) {
      const enableTom = user?.company?.applications?.some(
        elm => elm?.enum === "TOM"
      );
      const enableJE = user?.company?.applications?.some(
        elm => elm?.enum === "JE"
      );

      const newTabs = [];
      if (enableTom) newTabs.push({ id: 1, title: "TOM" });
      if (enableJE) newTabs.push({ id: 2, title: "TAREF" });

      setTabs(newTabs);

      // if only JE is enabled, switch active tab to it
      if (enableJE && !enableTom) setActiveTab(2);
    } else if (tabs.length === 0) {
      setTabs([
        { id: 1, title: "TOM" },
        { id: 2, title: "TAREF" },
      ]);
    }
  }, [user]);

  useEffect(
    () => {
      if (selected_user) {
        // const applications = selected_user.applications.map(
        //   (item: any) => item.enum
        // );
        // setApplicationArray(applications);
        setFirstName(selected_user.first_name);
        setLastName(selected_user.last_name);
        setPhoneNumber({
          code: selected_user?.phone_code,
          phone: selected_user?.phone_number,
        });
        setEmail(selected_user.email);
        setTomData({
          grant_access: selected_user?.roles?.TOM?.grant_access,
          name: selected_user?.roles?.TOM?.name,
          description: selected_user?.roles?.TOM?.description,
          metafield: {
            business_units:
              selected_user?.roles?.TOM?.metafield?.business_units.map(
                (elm: any) => elm.id
              ),
            regions: selected_user?.roles?.TOM?.metafield?.regions.map(
              (elm: any) => elm.id
            ),
            countries: selected_user?.roles?.TOM?.metafield?.countries.map(
              (elm: any) => elm.id
            ),
            grades: selected_user?.roles?.TOM?.metafield?.grades.map(
              (elm: any) => elm.id
            ),
            company_job_functions:
              selected_user?.roles?.TOM?.metafield?.company_job_functions?.map(
                (elm: any) => elm.id
              ) || [],
          },
          role_metafield: {
            has_live_pay_tool:
              selected_user?.roles?.TOM?.role_metafield?.has_live_pay_tool ||
              false,
          },
          permissions: selected_user?.roles?.TOM?.permissions.map(
            (elm: any) => elm
          ),
        });
        setJeData({
          grant_access: selected_user?.roles?.JE?.grant_access,
          name: selected_user?.roles?.JE?.name,
          description: selected_user?.roles?.JE?.description,
          metafield: {
            business_units:
              selected_user?.roles?.JE?.metafield?.business_units.map(
                (elm: any) => elm.id
              ),
            regions: selected_user?.roles?.JE?.metafield?.regions.map(
              (elm: any) => elm.id
            ),
            countries: selected_user?.roles?.JE?.metafield?.countries.map(
              (elm: any) => elm.id
            ),
            grades: selected_user?.roles?.JE?.metafield?.grades.map(
              (elm: any) => elm.id
            ),
            company_job_functions:
              selected_user?.roles?.JE?.metafield?.company_job_functions?.map(
                (elm: any) => elm.id
              ) || [],
          },
          role_metafield: {
            has_live_pay_tool:
              selected_user?.roles?.JE?.role_metafield?.has_live_pay_tool ||
              false,
          },
          permissions: selected_user?.roles?.JE?.permissions.map(
            (elm: any) => elm
          ),
        });

        const values = {
          first_name: selected_user.first_name,
          last_name: selected_user.last_name,
          phoneNumber: {
            code: selected_user?.phone_code,
            phone: selected_user?.phone_number,
          },
          email: selected_user.email,
          remember: true,
        };
        form.setFieldsValue(values);
        initializeForm.current = false; // prevent form re-initilization when any request is refetched.
      }
    },
    // eslint-disable-next-line
    [form, selected_user]
  );

  const handleTabData = (key: string, data: any) => {
    if (key === "tom") setTomData(data);
    else if (key === "je") setJeData(data);
    else if (key === "tom_validation") setValidateTom(() => data);
    else if (key === "je_validation") setValidateJe(() => data);
  };

  // new
  const onSubmit = async (payload: any) => {
    let appArr = [];
    const tempRoles: any = {};

    // Inside onSubmit:
    if (!validateTom() || !validateJe()) {
      customErrorMessage("Please fill all required fields before submitting.");
      return;
    }

    if (tomData?.grant_access) {
      appArr.push("TOM");
      tempRoles.TOM = {
        ...tomData,
        name: tomData.name?.trim() || "TOM User Role",
        description:
          tomData.description?.trim() || "TOM Application Access Role",
      };
    }

    if (jeData?.grant_access) {
      appArr.push("JE");
      tempRoles.JE = {
        ...jeData,
        name: jeData.name?.trim() || "JE User Role",
        description: jeData.description?.trim() || "Job Evaluation Access Role",
      };
    }

    if (appArr.length === 0) {
      customErrorMessage(
        "At least one application (TOM or JE) must be granted access"
      );
      return;
    }

    const primaryRole = tempRoles.TOM || tempRoles.JE;

    try {
      const extraPermissions = ["CREATE_LBT_REPORT", "VIEW_LBT_REPORT"];

      const data: any = {
        first_name: firstName,
        last_name: lastName,
        phone_number: phoneNumber.phone,
        phone_code: phoneNumber.code,
        applications: appArr,
        email: email,
        role: {
          name: primaryRole.name,
          description: primaryRole.description,
          grant_access: primaryRole.grant_access,
          metafield: primaryRole.metafield,
          permissions: [...(primaryRole.permissions || [])],
        },
        roles: {
          ...(tempRoles.TOM && { TOM: tempRoles.TOM }),
          ...(tempRoles.JE && { JE: tempRoles.JE }),
        },
      };

      // Only add new password if provided
      if (newPass && newPass.trim() !== "") {
        data.new_password = newPass;
      }

      // ✅ Inject extra permissions ONLY if TOM.has_live_pay_tool is true
      // if (data.roles?.TOM?.role_metafield?.has_live_pay_tool) {
      //   const dedupe = (arr: string[]) =>
      //     Array.from(new Set([...(arr || []), ...extraPermissions]));

      //   // Add to primary role
      //   data.role.permissions = dedupe(data.role.permissions);

      //   // Add to TOM role
      //   if (data.roles.TOM) {
      //     data.roles.TOM.permissions = dedupe(data.roles.TOM.permissions);
      //   }
      // }
      // ✅ Inject or remove extra permissions based on toggle
      // const extraPermissions = ["CREATE_LBT_REPORT", "VIEW_LBT_REPORT"];
      const cleanPermissions = (arr: string[]) =>
        (arr || []).filter(p => !extraPermissions.includes(p));

      if (data.roles?.TOM?.role_metafield?.has_live_pay_tool) {
        // Add when toggle is ON
        const dedupe = (arr: string[]) =>
          Array.from(new Set([...(arr || []), ...extraPermissions]));

        data.role.permissions = dedupe(data.role.permissions);

        if (data.roles.TOM) {
          data.roles.TOM.permissions = dedupe(data.roles.TOM.permissions);
        }
      } else {
        // 🧹 Remove when toggle is OFF
        data.role.permissions = cleanPermissions(data.role.permissions);

        if (data.roles.TOM) {
          data.roles.TOM.permissions = cleanPermissions(
            data.roles.TOM.permissions
          );
        }
      }

      const dedupe = (arr: string[] = [], perms: string[] = []) =>
        Array.from(new Set([...arr, ...perms]));

      // TOM role permissions
      if (data.roles?.TOM?.name) {
        const tomRolePerms =
          companyRolePermissions[
            data.roles.TOM.name as keyof typeof companyRolePermissions
          ] || [];

        if (tomRolePerms.length) {
          data.roles.TOM.permissions = dedupe(
            data.roles.TOM.permissions,
            tomRolePerms
          );

          data.role.permissions = dedupe(data.role.permissions, tomRolePerms);
        }
      }

      // JE role permissions
      if (data.roles?.JE?.name) {
        const jeRolePerms =
          companyRolePermissions[
            data.roles.JE.name as keyof typeof companyRolePermissions
          ] || [];

        if (jeRolePerms.length) {
          data.roles.JE.permissions = dedupe(
            data.roles.JE.permissions,
            jeRolePerms
          );

          data.role.permissions = dedupe(data.role.permissions, jeRolePerms);
        }
      }

      // ✅ Update vs Create logic unchanged
      if (company_user_id) {
        await updateCompanyUser({
          body: data,
          company_id,
          id: selected_user?.id,
        }).unwrap();
      } else {
        await createCompanyUser({ body: data, company_id }).unwrap();
      }

      // ✅ Reset state + form as before
      companyUserForm.current.resetFields();
      setTomData({});
      setJeData({});
      message.success(
        `Company User has been successfully ${
          company_user_id ? "updated" : "created"
        }.`
      );
      history.goBack();
    } catch (error) {
      console.log("Detailed error:", error);
      ErrorServices(error);
    }
  };

  return (
    <div>
      {/* <h1 className="form_heading  mb-6">{`${company_user_id ? "Update" : "Create"
        } Company-User`}</h1> */}
      <ConfigProvider locale={en}>
        <Form
          name="sub_admin"
          form={form}
          ref={companyUserForm}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          initialValues={{
            remember: true,
          }}
          onFinish={onSubmit}
          layout="vertical"
          className="create_company_container"
        >
          <div className="bg-blue-100 rounded-lg p-5">
            <h2 className="text-center text-gray-700 font-medium text-lg mb-8">
              Basic Information
            </h2>

            <Row gutter={[24, 20]}>
              <Col xs={24} md={12}>
                <Form.Item
                  label={
                    <label className="input__label text-xs text-blue-500">
                      First Name
                    </label>
                  }
                  name="first_name"
                  rules={[
                    {
                      required: true,
                      message: "Please enter first name",
                    },
                  ]}
                >
                  <Input
                    className="borderless-input h-10 rounded"
                    placeholder="Enter First Name Here..."
                    value={firstName}
                    onChange={e => setFirstName(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  label={
                    <label className="input__label text-xs text-blue-500">
                      Last Name
                    </label>
                  }
                  name="last_name"
                  rules={[
                    {
                      required: true,
                      message: "Please enter last name",
                    },
                  ]}
                >
                  <Input
                    className="borderless-input h-10 rounded"
                    placeholder="Enter Last Name Here..."
                    value={lastName}
                    onChange={e => setLastName(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  label={
                    <label className="input__label text-xs text-blue-500">
                      Contact Number
                    </label>
                  }
                  name="phoneNumber"
                >
                  <ConfigProvider locale={en}>
                    <CountryPhoneInput
                      name="phoneNumber"
                      value={{
                        phone: phoneNumber?.phone,
                        code: phoneNumber?.code || 92,
                      }}
                      onChange={v => setPhoneNumber(v)}
                    />
                  </ConfigProvider>
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  label={
                    <label className="input__label text-xs text-blue-500">
                      Email Address
                    </label>
                  }
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please enter email address",
                    },
                  ]}
                >
                  <Input
                    className="borderless-input h-10 rounded"
                    placeholder="Enter Email Address Here..."
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                </Form.Item>
              </Col>

              {location.pathname.includes("edit") && (
                <Col xs={24} md={12}>
                  <Form.Item
                    label={
                      <label className="input__label text-xs text-blue-500">
                        Change Password
                      </label>
                    }
                    name="changePassword"
                  >
                    <Input.Password
                      className="borderless-input h-10 rounded"
                      placeholder="Enter New Password"
                      value={newPass}
                      onChange={e => setNewPass(e.target.value)}
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>

            <div className="w-full bg-blue-500 rounded-lg p-1 flex justify-center items-center gap-1 mb-6">
              {tabs.map((tab: any) => (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveTab(tab.id)}
                  className={
                    activeTab === tab.id
                      ? "w-32 h-10 shadow-lg bg-white text-blue-500 rounded-md text-xs font-semibold transition duration-200"
                      : "w-32 h-10 bg-transparent text-white rounded-md text-xs font-semibold transition duration-200 hover:bg-blue-400"
                  }
                >
                  {tab.title}
                </button>
              ))}
            </div>

            {activeTab === 1 && (
              <TomTab
                selected_user={selected_user}
                TomData={tomData}
                createDataCallback={handleTabData}
              />
            )}
            {activeTab === 2 && (
              <JeTab JeData={jeData} createDataCallback={handleTabData} />
            )}
          </div>

          <div className="flex flex-row w-full items-center justify-center gap-5 nt-10 bottom-0 left-0 right-0 mx-auto overflow-x-hidden fixed bg-white py-4">
            {/* Submit Button */}
            <div className="w-max">
              <button
                disabled={isLoading || isUpdating}
                onClick={() => {}} //Submit handled by form itself
                type="submit"
                className={`block bg-themeCore text-white py-2 px-5 rounded-md w-full ${
                  isLoading || isUpdating ? "!bg-gray-400" : ""
                }`}
              >
                {`${company_user_id ? "Update" : "Create"} Company-User`}
              </button>
            </div>

            <div className="w-max">
              <button
                type="button"
                onClick={() => {
                  history.goBack();
                }}
                className="block text-white py-2 px-5 rounded-md w-full"
                style={{ background: "#F7935A" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </Form>
      </ConfigProvider>
    </div>
  );
};

export default CreateCompanyUser;
